import { SurveyResponse } from "@/modules/session-survey/types/SurveyResponse";
import { SurveyStatus } from "@/modules/session-survey/types/SurveyStatus";
import { apiClient } from "@/modules/shared/utils/apiClient";

interface SubmitSurveyResponse {
  surveyId: string;
  status: SurveyStatus;
}

export const submitSurveyResponses = async (
  surveyId: string,
  responses: SurveyResponse[],
): Promise<SubmitSurveyResponse> =>
  apiClient.patch<SubmitSurveyResponse>(`/survey/${surveyId}`, {
    responses: responses.map((response) => ({
      questionId: response.questionId,
      value: response.value,
    })),
  });
